module.exports = __webpack_public_path__ + "img/electric.2cf7d8d8.svg";